/* eslint-disable jsx-a11y/alt-text */
import { Grid, Box } from '@material-ui/core';
import React from 'react';
import { moneyFormat, simpleDateFormatter } from '../Shared/colorFormat';

export class ExpensesPrint extends React.PureComponent<any, any> {
  renderHeader = (company: any) => (
    <Grid item xs={12}>
      <img
        src={company?.header}
        alt={company?.name}
        height="auto"
        width="100%"
        style={{
          objectFit: 'contain',
        }}
      />
    </Grid>
  );
  renderTitle = (printData: any) => (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div style={{ fontSize: 40, letterSpacing: 2, marginBottom: 15 }}>
            EXPENSES
          </div>
          <Grid container spacing={0}>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <div style={{ fontWeight: 'bold', fontSize: 14 }}>Date:</div>
            </Grid>
            <Grid item xs={4}>
              <div style={{ fontSize: 14 }}>
                {simpleDateFormatter(printData?.time)}
              </div>
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <div style={{ fontWeight: 'bold', fontSize: 14 }}>
                Expenses No:
              </div>
            </Grid>
            <Grid item xs={4}>
              <div style={{ fontSize: 14 }}>{printData.no}</div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              textTransform: 'uppercase',
            }}
          >
            {printData.title}
          </div>
          {printData?.supplier && (
            <div style={{ fontSize: 14 }}>{printData?.supplier?.name}</div>
          )}
          {printData?.resourse && (
            <div style={{ fontSize: 14 }}>{printData?.resourse?.name}</div>
          )}
          {printData?.employee && (
            <div style={{ fontSize: 14 }}>{printData?.employee?.name}</div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
  renderTableHeader = () => {
    return (
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
              height: 60,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            No
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
              height: 60,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div>Item Description</div>
            <div>التفاصيل</div>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: 60,
            }}
          >
            <div>Price</div>
            <div>السعر</div>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: 60,
            }}
          >
            <div>Qty</div>
            <div>الكمية</div>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: 14,
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: 60,
            }}
          >
            <div>Total</div>
            <div>المجموع</div>
          </Box>
        </Grid>
      </Grid>
    );
  };
  renderItem = (item: any) => {
    var trimmed = `${item.name} - ${item.desc && item.desc}  ${
      item.note && item.note
    }`;
    return (
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 5,
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 30,
            }}
          >
            {item.index + 1}
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 5,
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              minHeight: 30,
            }}
          >
            <div>{trimmed}</div>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 5,
              fontSize: 14,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              minHeight: 30,
            }}
          >
            {moneyFormat(item.itemprice)}
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 5,
              fontSize: 14,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 30,
            }}
          >
            {item.itemqty}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 5,
              fontSize: 14,
              fontWeight: 'bold',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              minHeight: 30,
            }}
          >
            {moneyFormat(item.itemtotal)}
          </Box>
        </Grid>
      </Grid>
    );
  };
  renderEmptyItem = () => {
    return (
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 14,
              fontSize: 14,

              textAlign: 'center',
              height: 30,
            }}
          ></Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 14,
              fontSize: 14,

              height: 30,
            }}
          ></Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 14,
              fontSize: 14,

              textAlign: 'right',
              height: 30,
            }}
          ></Box>
        </Grid>
        <Grid item xs={1}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 14,
              fontSize: 14,

              textAlign: 'center',
              height: 30,
            }}
          ></Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            borderTop={1}
            borderColor="grey.300"
            style={{
              padding: 14,
              fontSize: 14,
              fontWeight: 'bold',

              textAlign: 'right',
              height: 30,
            }}
          ></Box>
        </Grid>
      </Grid>
    );
  };
  renderGrandTotal = () => {
    const netamount = this.props.printData?.amount;
    return (
      <Grid container spacing={0}>
        {this.renderDivider(3)}
        <Grid item xs={7}></Grid>
        <Grid item xs={3}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              padding: 6,
              fontSize: 14,
              fontWeight: 'bold',
              height: 60,
              backgroundColor: '#f5f5f5',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div>Grand Total</div>
            <div>المبلغ الإجمالي</div>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            border={1}
            borderColor="grey.300"
            style={{
              padding: 6,
              fontSize: 16,
              fontWeight: 'bold',
              height: 60,
              backgroundColor: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {moneyFormat(netamount)}
          </Box>
        </Grid>
      </Grid>
    );
  };
  renderFooter = (user: any) => (
    <Grid item xs={12}>
      <Grid container spacing={0}>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'center',
              fontSize: 14,
            }}
          >
            <div style={{ fontWeight: 'bold' }}>
              {user.name ? user.name : user.username}
            </div>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
  renderTableItems = (items: any) => {
    return items?.map((item: any) => {
      return this.renderItem(item);
    });
  };
  renderDivider = (x: number) => (
    <Grid item xs={12}>
      <Box m={x}></Box>
    </Grid>
  );
  render() {
    const { company, user, printData } = this.props;
    const items = printData?.items;
    return (
      <Box>
        <Box>
          <Grid container spacing={0}>
            {this.renderHeader(company)}
            <Grid item xs={12}>
              <Box ml={6} mr={6}>
                <Grid container spacing={2}>
                  {this.renderDivider(2)}
                  {this.renderTitle(printData)}
                  {this.renderDivider(3)}
                  {this.renderTableHeader()}
                  {this.renderTableItems(items)}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box ml={6} mr={6}>
                <Grid container spacing={2}>
                  {this.renderDivider(6)}
                  {this.renderGrandTotal()}
                  {this.renderDivider(4)}
                  {this.renderFooter(user)}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }
}
